$(document).ready(function () {

    $(".trustpilot-overlay").on("click", function (e) {
        $("#reviewTabTP").click()
        const review = $('#reviewTabTP');
        if (review.length) {
            $('html, body').animate({
                scrollTop: review.offset().top - 150
            }, 2000);
        }
    })

    let productsSliderOptions = {
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: false,
                    infinite: true,
                    arrows: true,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    infinite: true,
                    arrows: true,
                }
            }
        ]
    };

    $(".js-product-list-slider").each(function() {

        $(this).slick(productsSliderOptions);

    });

    // Product details images slider page
    let productsDetailsSliderOptions = {
        arrows: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                }
            },
            {
                breakpoint: 576,
                settings: {
                }
            }
        ]
    };

    $(".js-products-details__slider").each(function() {

        var $slider = $(this);

        $slider.slick(productsDetailsSliderOptions);

        $slider.find(".product-details__image > img").click(function () {
            var index = $(this).data('slide-to');
            $('#gallery-modal').modal('show');
            $('#gallery-carousel').carousel(index);
        });
    });

    $(".js-products-details__slider").each(function() {

        let $slider = $(this);
        if ($slider.hasClass("initialized")) return;

        const $sliderDotsContainer = $slider.find(".slick-dots");
        const $sliderDots = $sliderDotsContainer.find("li");
        const counterDots = $sliderDots.length;

        if(counterDots > 1) {
            let widthDots = 100 / counterDots + '%';
            $sliderDots.css('width', widthDots);
            $slider.addClass("initialized");
        } else {
            $sliderDotsContainer.css('height', 'auto');
            $sliderDots.css('display', 'none');
            $slider.addClass("initialized");
        }
        $slider.addClass("initialized");
    });

    // Refurbished
    $(".refurbished-info").on("click", function () {
        let idTable = $(this).data("table")
        let idBuyButton = $(this).data("buybtn")
        let code = $(this).data("code")

        $("[id^=refurbished-table-]").each(function () {
            $(this).addClass("d-none")
        })
        $("#"+idTable).removeClass("d-none")

        $("[id^=buyBtn-]").each(function () {
            $(this).addClass("d-none")
        })
        $("#"+idBuyButton).removeClass("d-none")

        $("[id^=code-]").each(function () {
            $(this).addClass("d-none")
        })
        $("#code-"+code).removeClass("d-none")

        $(".refurbished-info.active").removeClass("active")
        $(this).addClass("active")

        let currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('code', code);
        window.history.replaceState({}, '', currentUrl);
    })
});

function showActiveProductCategory(keyframes, options){
    const $scrollBar = $('.tab-component.js-tab-component');
    let $currentEl = $('.tab-component__button');

    if($currentEl){
        $currentEl.click(function() {
            let current = $(this);
            let offset = 0;

            while(current.prev().hasClass('tab-component__button')){
                current = current.prev(); offset += current.width();
            }

            let new_offset = offset - $scrollBar.scrollLeft();
            $scrollBar.animate({ scrollLeft: '+=' + new_offset }, 300, 'swing');
        });
    }
}
const openBackInStock = () => {
    const queryParameter = 'openBackInStock';
    const targetElement = $('.js_backInStock')
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const isAlternativeProduct = urlParams.get(queryParameter)
    if(isAlternativeProduct) {
        targetElement.click();
        window.history.pushState({}, document.title, removeURLParameter(window.location.href,queryParameter));
    }
}

function zoomImage(){
    $('.zoomable-image.zoomable-image').trigger('zoom.destroy');
    $('.carousel-item.active.zoomable-image').zoom({on: 'click', magnify: 2, touch: true,
        onZoomIn: function() {
            $('.zoom-plus').hide();
            $('.zoom-minus').show();
        },
        onZoomOut: function() {
            $('.zoom-minus').hide();
            $('.zoom-plus').show();
        }
    });
}


function initProductDetail() {
    showActiveProductCategory();
    openBackInStock();

    const hash = window.location.hash;
    if (hash) {
        const targetTabId = hash.substring(1); // Rimuove il #
        setTimeout(() => {
            const $targetTab = $('#' + targetTabId);
            if ($targetTab.length > 0 && $targetTab.hasClass('tab-component__button')) {
                $targetTab.trigger('click');

                // Scroll
                $('html, body').animate({
                    scrollTop: $targetTab.offset().top - 150
                }, 1000);
            }
        }, 500);
    }

    $('#gallery-modal').on('show.bs.modal', function (event) {
        $('.zoom-minus').hide();
        $('.zoom-plus').show();
        zoomImage()

        $('#gallery-carousel-modal').on('slide.bs.carousel', function() {
            setTimeout(() => {
                zoomImage()
            }, "1000");
        });
    });
}

$(document).ready(initProductDetail);
